export const STEPS = {
    START: 'START',
    LOGIN: 'LOGIN',
    VERIFY_LOGIN: 'VERIFY_LOGIN',
    GET_ACCOUNT_INFO: 'GET_ACCOUNT_INFO',
    APP_SELECT: 'APP_SELECT',
    ADD_SERVICES: 'ADD_SERVICES',
    APP_INFO: 'APP_INFO',
    FINALIZE_INFO: 'FINALIZE_INFO',
    COMPLETE: 'COMPLETE',
};

export const servicesUrl = [
    '/CustomerInformation/verifyMobileCarrier',
    '/IdentityVerification/NIP',
    '/BusinessInformation/CAC/Basic',
    '/IdentityVerification/Ghana-PID',
    '/BusinessInformation/TIN',
    '/IdentityVerification/PVC',
    '/IdentityVerification/Ghana-VID',
    '/IdentityVerification/DriverLicence',
    '/IdentityVerification/NIN',
    '/IdentityVerification/BVN',
    '/IdentityVerification/Ghana-COC',
    '/IdentityVerification/LivenessCheckAdvanced',
    '/Aml/Sanctions',
    '/BusinessInformation/CAC/CompanySearch',
];

const prodCardVerificationServices = [
    {
        id: 17,
        service_name: 'Phone Number',
        service_url: '/CustomerInformation/verifyMobileCarrier',
        payload: 'phone_number,country_code',
    },
    {
        id: 2,
        service_name: 'National Identity Number (NIN)',
        service_url: '/IdentityVerification/NIN',
        payload: 'phone_number,nin_number',
    },
    {
        id: 1,
        service_name: 'Bank Verification Number (BVN)',
        service_url: '/IdentityVerification/BVN',
        payload: 'phone_number,bvn_number',
    },
];

export const prodVerificationsServices = [
    ...prodCardVerificationServices,
    {
        id: 31,
        service_name: 'Certificate of Incorporation (CAC) - Basic enquiry',
        service_url: '/BusinessInformation/CAC/Basic',
        payload: 'registration_number,country_code',
    },
    {
        id: 5,
        service_name: 'NGN International Passport',
        service_url: '/IdentityVerification/NIP',
        payload: 'phone_number,passport_number,first_name,last_name,dob',
    },
    {
        id: 22,
        service_name: 'Ghana International Passport',
        service_url: '/IdentityVerification/Ghana-PID',
        payload: 'phone_number,passportno,include_pic',
    },
    {
        id: 3,
        service_name: `Permanent Voter's Card`,
        service_url: '/IdentityVerification/PVC',
        payload: 'phone_number,last_name,state,pvc_number',
    },
    {
        id: 20,
        service_name: `Ghana Voter's Card`,
        service_url: '/IdentityVerification/Ghana-VID',
        payload: 'phone_number,voter_id,include_pic',
    },
    {
        id: 4,
        service_name: 'Drivers Licence',
        service_url: '/IdentityVerification/DriverLicence',
        payload: 'phone_number,license_number,first_name,last_name,dob',
    },
    {
        id: 21,
        service_name: 'Ghana Drivers License',
        service_url: '/IdentityVerification/Ghana-COC',
        payload: 'phone_number,certificate_of_competence,include_pic',
    },
    {
        id: 32,
        service_name: 'Tax Identification Number (TIN)',
        service_url: '/BusinessInformation/TIN',
        payload: 'criteria,criteriaValue',
    },
    {
        id: 36,
        service_name: 'Liveness Check (Advanced)',
        service_url: '/IdentityVerification/LivenessCheckAdvanced',
        payload: 'phone_number,video,image',
    },
    {
        id: 41,
        service_label: 'Aml',
        service_url: '/Aml/Sanctions',
        payload: 'name,search_type',
    },
    {
        id: 314,
        service_label: 'CAC Company Search',
        service_url: '/BusinessInformation/CAC/CompanySearch',
        payload: 'company_name,type',
    },
];

export const devCardVerificationsServices = [
    {
        id: 25,
        service_name: 'Phone Number',
        service_url: '/CustomerInformation/verifyMobileCarrier',
        payload: 'phone_number,country_code',
    },
    {
        id: 2,
        service_name: 'National Identity Number (NIN)',
        service_url: '/IdentityVerification/NIN',
        payload: 'phone_number,nin_number',
    },
    {
        id: 1,
        service_name: 'Bank Verification Number (BVN)',
        service_url: '/IdentityVerification/BVN',
        payload: 'phone_number,bvn_number',
    },
];

export const devVerificationsServices = [
    ...devCardVerificationsServices,
    {
        id: 48,
        service_name: 'Certificate of Incorporation (CAC) - Basic enquiry',
        service_url: '/BusinessInformation/CAC/Basic',
        payload: 'registration_number,country_code',
    },
    {
        id: 5,
        service_name: 'NGN International Passport',
        service_url: '/IdentityVerification/NIP',
        payload: 'phone_number,passport_number,first_name,last_name,dob',
    },
    {
        id: 44,
        service_name: 'Ghana International Passport',
        service_url: '/IdentityVerification/Ghana-PID',
        payload: 'phone_number,passportno,include_pic',
    },
    {
        id: 3,
        service_name: `Permanent Voter's Card`,
        service_url: '/IdentityVerification/PVC',
        payload: 'phone_number,last_name,state,pvc_number',
    },
    {
        id: 43,
        service_name: `Ghana Voter's Card`,
        service_url: '/IdentityVerification/Ghana-VID',
        payload: 'phone_number,voter_id,include_pic',
    },
    {
        id: 4,
        service_name: 'Drivers Licence',
        service_url: '/IdentityVerification/DriverLicence',
        payload: 'phone_number,license_number,first_name,last_name,dob',
    },

    {
        id: 47,
        service_name: 'Ghana Drivers License',
        service_url: '/IdentityVerification/Ghana-COC',
        payload: 'phone_number,certificate_of_competence,include_pic',
    },
    {
        id: 38,
        service_name: 'Tax Identification Number (TIN)',
        service_url: '/BusinessInformation/TIN',
        payload: 'criteria,criteriaValue',
    },
    {
        id: 27,
        service_name: 'Liveness Check (Advanced)',
        service_url: '/IdentityVerification/LivenessCheckAdvanced',
        payload: 'phone_number,video,image',
    },
    {
        id: 51,
        service_name: 'Aml',
        service_url: '/Aml/Sanctions',
        payload: 'name,search_type',
    },
    {
        id: 330,
        service_name: 'CAC Company Search',
        service_url: '/BusinessInformation/CAC/CompanySearch',
        payload: 'company_name,type',
    },
];

export const getVerificationServices = () => {
    const env = process.env.REACT_APP_ENV;
    if (env === 'dev') return devVerificationsServices;
    else return prodVerificationsServices;
};

export const getCardVerificationServices = () => {
    const env = process.env.REACT_APP_ENV;
    if (env === 'dev') return devCardVerificationsServices;
    else return prodCardVerificationServices;
};
